// extracted by mini-css-extract-plugin
module.exports = {"downloadBtn":"styles_downloadBtn__1d8IL","item":"styles_item__196q2"};